export const camelToSnakeCase = (str: string): string =>
  str.replace(/(?!^)[A-Z0-9]/g, (match) => `_${match.toLowerCase()}`)

export const snakeToCamelCase = (str: string): string =>
  str.replace(/_([a-z0-9])/g, (_, m) => m.toUpperCase())

export const camelToSeparate = (str: string): string =>
  str.replace(/([a-z])([A-Z])/g, '$1 $2')
